<template>
  <vetster-slide-over
    ref="slideOver"
    container-classes="lg:!h-fit"
    :is-slidein="!$screen('lg')"
  >
    <template #content>
      <div class="pt-4 pb-8 px-4 sm:px-6 space-y-3.5">
        <button
          type="button"
          class="text-neutral-700"
          @click="close"
        >
          <fa
            :icon="['far', 'xmark']"
            class="text-xl"
          />
        </button>
        <vetster-title>
          {{ $t('search.what-does-it-mean-if-your-vet-is-out-of-state') }}
        </vetster-title>
        <p class="text-neutral-500">
          {{ $t('search.your-out-of-state-vet-cannot-prescribe') }}
        </p>
      </div>
    </template>
  </vetster-slide-over>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faXmark } from '@fortawesome/pro-regular-svg-icons';

import VetsterSlideOver from '@/brand-components/VetsterSlideOver';
import VetsterTitle from '@/brand-components/VetsterTitle';

library.add(faXmark);

export default {
  name: 'VetsterOutOfStateInfoSlideOver',

  components: {
    VetsterSlideOver,
    VetsterTitle,
  },

  methods: {
    close() {
      this.$refs.slideOver.close();
    },
    open() {
      this.$refs.slideOver.open();
    },
  },
};
</script>
